import { Injectable } from "@angular/core";

import { environment } from '@env/environment';
import { LogLevelEnum } from "@infrastructure/logLevel.enum";
import { UAParser } from 'ua-parser-js';
import { HttpService } from './http.service';
import { ServerInfoService } from "./server-info.service";

@Injectable({
	providedIn: "root"
})
export class LoggerService {

	constructor(
		private httpService: HttpService,
		private serverInfoService: ServerInfoService
	) { }

	async sendClientLog(logEvent: LogEvent) {
		try {
			const parser = new UAParser();
			const clientInfo = parser.getResult();
			logEvent.extraPropertiesToLog['clientInfo'] = JSON.stringify(clientInfo);

			const serverInfo = {
				dataServer: {
					url: environment.dataUrl,
					info: (await this.serverInfoService.getServerInfo())

				},
				imageServer: {
					url: environment.imageUrl,
					cdnUrl: environment.imageCDNUrl,
					info: (await this.serverInfoService.getImageServerInfo())
				}
			}
			logEvent.extraPropertiesToLog['serverInfo'] = JSON.stringify(serverInfo);

			return await this.httpService.postWithOfflineHandling<string>(`${environment.dataUrl}/log/addclientexception`, logEvent)
				.catch((error) => {
					console.error("sendClientLog failed", logEvent, error);
				});
		}
		catch (error) {
			console.error("Error in sendClientException", logEvent);
		}
	}

}

export class LogEvent {
	constructor(
		public message: string,
		public logLevel: LogLevelEnum,
		public extraPropertiesToLog: {
			[key: string]: string
		}
	) { }
}
